/**
 * Merge draft text fields onto site projects, preserving webpack images/carousels.
 */
export const mergeProjectsWithDraft = (siteProjects, draftProjects) => {
  if (!Array.isArray(draftProjects) || draftProjects.length === 0) {
    return siteProjects;
  }
  const siteById = new Map(siteProjects.map((p) => [p.id, p]));
  const seen = new Set();
  const merged = draftProjects.map((draft) => {
    const site = siteById.get(draft.id) || {};
    seen.add(draft.id);
    return {
      ...site,
      ...draft,
      img: site.img || draft.img,
      carouselData: site.carouselData || draft.carouselData || [],
    };
  });
  siteProjects.forEach((site) => {
    if (!seen.has(site.id)) merged.push(site);
  });
  return merged;
};

/** Card blurb: first paragraph, plain text (matches PhD short summaries). */
export const projectCardBlurb = (description = "") => {
  const raw = String(description || "");
  const firstPara = raw.split(/\n\n/)[0] || raw;
  return firstPara
    .replace(/<[^>]+>/g, "")
    .replace(/\s+/g, " ")
    .trim();
};

/** Serializable fields for studio draft / sync (images stay in src/data). */
export const toEditableProject = (project) => ({
  id: project.id,
  title: project.title || "",
  year: project.year || "",
  description: project.description || "",
  github: project.github || "",
  report: project.report || "",
  youtube: project.youtube || "",
  type: project.type || "",
});
